// ============================================================================
// Navbar — thin switcher between NavbarV1 (original sticky top, marketing
// anchor links) and NavbarV3 (slim 2026 fixed, context-aware auth/public
// modes). Driven by the admin Site Design toggle.
// ============================================================================
import React from 'react';
import { useDesignVersion } from '@/hooks/useDesignVersion';
import NavbarV1 from './NavbarV1';
import NavbarV3 from './NavbarV3';

const Navbar = () => {
  const v = useDesignVersion();
  return v === 'v1' ? <NavbarV1 /> : <NavbarV3 />;
};

export default Navbar;
